import { useEffect, useState } from "react"

function readIsDarkMode() {
  if (typeof document === "undefined") return false
  return document.documentElement.classList.contains("dark")
}

/** Re-renders when the html `dark` class or `data-theme` attribute changes. */
export default function useIsDarkMode() {
  const [isDark, setIsDark] = useState(readIsDarkMode)

  useEffect(() => {
    const html = document.documentElement
    const sync = () => setIsDark(html.classList.contains("dark"))

    const observer = new MutationObserver(sync)
    observer.observe(html, { attributes: true, attributeFilter: ["class", "data-theme"] })

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)")
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", sync)
    } else {
      mediaQuery.addListener(sync)
    }

    return () => {
      observer.disconnect()
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", sync)
      } else {
        mediaQuery.removeListener(sync)
      }
    }
  }, [])

  return isDark
}
